import React  from "react";

import { Provider } from 'react-redux';
import { PersistGate } from "redux-persist/integration/react";

import { store, persistor } from "./store";

// import PrivacyPopup from "../components/PrivacyPopup";

export default ({ element, props }) => { // 
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                    {element}
                    {/*<PrivacyPopup />*/}
            </PersistGate>
        </Provider>
    );
}